// WHIT-485 round 3: favourite hotels — the incumbent's /kedvelt-szallasok/
// ("Kedvenc szállások"). Each customer's list is kept by taurus-api; a visitor
// without an account marks hotels as an anonymous Firebase user, and the list
// follows them when they sign in, as package bookings do.
// Pure (no DOM, no React) so `node --test web/utils/favouriteHotels.test.js`
// can load it.

const { landingSearch } = require('./packageLandingPages');

const FAVOURITES_PATH = '/package-tours/favourites/';
const FAVOURITES_HU_PATH = '/kedvelt-szallasok/';

// The urlTranslations entry for the Hungarian address.
const favouritesRewrites = () => ({
  [FAVOURITES_HU_PATH]: { locale: 'hu', rewriteUrl: FAVOURITES_PATH },
});

/** @typedef {{ hotelId: string, name: string | null }} FavouriteHotel */

/**
 * @param {FavouriteHotel[] | null} hotels
 * @param {string} hotelId
 */
const isFavourite = (hotels, hotelId) =>
  !!hotels && hotels.some(hotel => hotel.hotelId === hotelId);

/**
 * The list as it will be once taurus-api has the change, shown while the
 * request is on its way. A new favourite goes first: the list is newest first.
 * @param {FavouriteHotel[] | null} hotels
 * @param {FavouriteHotel} hotel
 * @param {boolean} favourite
 */
const withFavourite = (hotels, hotel, favourite) => {
  const others = (hotels || []).filter(h => h.hotelId !== hotel.hotelId);
  return favourite
    ? [{ hotelId: hotel.hotelId, name: hotel.name }, ...others]
    : others;
};

// A favourite has no dates of its own; its page opens with a destination
// page's: departures from a week out, for 30 days.
const favouriteSearch = today => landingSearch({ search: {} }, today);

module.exports = {
  FAVOURITES_PATH,
  FAVOURITES_HU_PATH,
  favouritesRewrites,
  isFavourite,
  withFavourite,
  favouriteSearch,
};
